module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABHNCSVQICAgIfAhkiAAAAVJJREFUSEu11c8rBGEYB/Dvl7Grtmw4kcJ/oNyWXJVwwFF2sy7Kj/wH+x/Ij3JBKUfrgJSrdqcctvwHVokbRm2ZMTx6Z41mZUvrfZ/jzDOfZ3p7n+ch6oTY2Y43eZ8WYBTAIIAkAAIQAA6AEoGLFjbnmdp7/I1RyTUhkmty7ZslgmsA+uoVjzwvC2Q9nurfJnMf0fwavFKY77YoO4BM/gH9kcITX7iYGN6/D19845XL2S7Lsk4hwRE0FkTJ9/2JxMjhgwICXM6X417y5QjgeGNq9Cs5izltMxzbcgP8tZheIbjxf7gqCGS1dehgk3I11+n5vAbYowsH5C5myQC9Qjor5K4+uCpRZIGunclDMKUbB3FMt5gpA+jVjgO3Clfd1W4Af1L481dr6/Yd439u8MxN3haj99xohxqdLcanoipgbJ6H3WNsE4UFjO3Qmn2iYft/AhCVt0SCk9JYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/circle.png
// module id = 327
// module chunks = 1